import { inject, Injectable } from '@angular/core';
import {
  ConsultantDossierJaune,
  GetDossierJauneFileUrlGQL,
  GetDossiersJaunesContentGQL,
  SetDossierJauneShortcutPathGQL,
} from '@graphql/generated';
import { AuthService } from '@lib/auth/auth.service';
import { DossierJaune } from '@lib/models/dossier-jaune/dossier-jaune';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';

@Injectable({ providedIn: 'root' })
export class DossiersJaunesService {
  private readonly getDossiersJaunesContentGql = inject(GetDossiersJaunesContentGQL);
  private readonly getDossierJauneFileUrlGql = inject(GetDossierJauneFileUrlGQL);
  private readonly setDossierJauneShortcutPathGql = inject(
    SetDossierJauneShortcutPathGQL
  );
  private readonly authService = inject(AuthService);

  public async getDossiersJaunesContent(
    folder: string,
    codeConsultant: string | null = null,
    archiveRole: number | null = null
  ): Promise<DossierJaune[]> {
    const queryResult = await lastValueFrom(
      this.getDossiersJaunesContentGql.fetch({
        variables: {
          codeConsultant: codeConsultant,
          folder: folder,
          archiveRole: archiveRole,
        },
        ...{ fetchPolicy: 'network-only' },
      })
    );

    return queryResult.data!.dossiersJaunesContent.map(
      d => ({ isFolder: d.isFolder, name: d.name, path: d.path }) as DossierJaune
    );
  }

  public async getDossierJauneFileUrl(path: string): Promise<string> {
    const queryResult = await lastValueFrom(
      this.getDossierJauneFileUrlGql.fetch({ variables: { path: path } })
    );

    return queryResult.data!.dossiersJaunesFileSasUri;
  }

  public async setDossierJauneShortcutPath(
    codeConsultant: string,
    newPath: string
  ): Promise<string> {
    const queryResult = await lastValueFrom(
      this.setDossierJauneShortcutPathGql.mutate({
        variables: {
          codeConsultant: codeConsultant,
          newPath: newPath,
        },
      })
    );

    return this.authService.isOnlyGcom()
      ? (queryResult.data?.dossiersJaunesSetShortcutPath?.consultantDossierJaune
          ?.shortcutPathGcom ?? '')
      : (queryResult.data?.dossiersJaunesSetShortcutPath?.consultantDossierJaune
          ?.shortcutPath ?? '');
  }
}
